<div id="gridConfigValidationDiv" class="grid-container">
  <!--Testata configurazione colonne-->
  <dx-data-grid
    id="gridConfigValidation"
    [dataSource]="gridConf.cols"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    (onRowUpdated)="onConfigRowUpdating($event)"
    [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
    (onToolbarPreparing)="hideButtons($event)"
    (onEditingStart)="saveData()"
  >
    <dxi-column alignment="center">
      <dxi-column
        [allowEditing]="false"
        dataField="dataField"
        [caption]="'Id' | siaTranslate"
        [width]="150"
      ></dxi-column>

      <dxi-column
        [allowEditing]="false"
        dataField="caption"
        [caption]="'Nome' | siaTranslate"
      ></dxi-column>
    </dxi-column>
    <dxi-column caption="Tipi Validazione" alignment="center">
      <dxi-column
        dataField="required"
        [caption]="'Obbligatorio' | siaTranslate"
        [width]="100"
        dataType="boolean"
      ></dxi-column>

      <dxi-column
        dataField="email"
        [caption]="'Email' | siaTranslate"
        [width]="100"
        dataType="boolean"
      ></dxi-column>
    </dxi-column>
    <dxi-column caption="Validazione Tramite Pattern" alignment="center">
      <dxi-column
        dataField="patternValue"
        [caption]="'Pattern usato' | siaTranslate"
        [width]="200"
        dataType="string"
      ></dxi-column>

      <dxi-column
        dataField="patternMessage"
        [caption]="'Messaggio Errore' | siaTranslate"
        [width]="200"
        dataType="string"
      ></dxi-column>
    </dxi-column>

    <dxo-editing
      mode="batch"
      refreshMode="repaint"
      as
      GridsEditRefreshMode
      [allowUpdating]="true"
      [selectTextOnEditStart]="selectTextOnEditStart"
      [startEditAction]="startEditAction"
    >
    </dxo-editing>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations [sorting]="true" [paging]="true">
    </dxo-remote-operations>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>
